import yup from 'src/libraries/validator.library';

export const FlightCategorySchema = yup
  .object({
    flightFlag: yup.number(),
    flightCategory: yup.string(),
    sortOrder: yup.number(),
  })
  .defined();

export const FlightCategoryListPayloadSchema = yup
  .object({
    count: yup.number().defined(),
    rows: yup.array().of(FlightCategorySchema).defined(),
  })
  .defined();

export type IFlightCategory = yup.InferType<typeof FlightCategorySchema>;
